/** Shared utilities for LMS monorepo. */
export function assertNever(value: never): never {
  throw new Error(`Unexpected value: ${String(value)}`);
}

export const APP_NAME = 'lms-web';
